import { render, staticRenderFns } from "./DarkMoodWorks.vue?vue&type=template&id=17678fa5&"
import script from "./DarkMoodWorks.vue?vue&type=script&lang=js&"
export * from "./DarkMoodWorks.vue?vue&type=script&lang=js&"
import style0 from "./DarkMoodWorks.vue?vue&type=style&index=0&id=17678fa5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports